/**
 * Whether a query string asks for the organisation settings wizard in onboarding mode
 * (`?onboarding=1`), where the post-activation redirect sends a new charity admin.
 *
 * The edit page reads it once to set up the wizard and then drops it from the address
 * bar, so the layout also reads it to hide its payment gateway prompt from the first
 * render, before the wizard has set itself up.
 */
export const isOnboardingSearch = (search: string | null | undefined) =>
  new URLSearchParams(search ?? '').get('onboarding') === '1';
